import moment from 'moment';
import { get } from 'lodash-es';

import { types as appTypes } from './app';

export const types = {
  GET_AUTH_TOKEN: 'APP/GET_AUTH_TOKEN',
  GET_AUTH_TOKEN_SUCCESS: 'APP/GET_AUTH_TOKEN_SUCCESS',
  GET_AUTH_TOKEN_FAILURE: 'APP/GET_AUTH_TOKEN_FAILURE',
  SIGNOUT: 'APP/SIGNOUT',
  SIGNOUT_SUCCESS: 'APP/SIGNOUT_SUCCESS',
  SIGNOUT_ERROR: 'APP/SIGNOUT_ERROR',
  CLEAR_AUTH: 'APP/CLEAR_AUTH',
  CLEAR_SIGNOUT: 'APP/CLEAR_SIGNOUT',
  TICK: 'APP/TICK',
  REFRESH_REQUEST: 'APP/REFRESH_REQUEST',
  REFRESH_SUCCESS: 'APP/REFRESH_SUCCESS',
  REFRESH_FAILURE: 'APP/REFRESH_FAILURE',
};

const initialState = {
  decodedJwt: {},
  authenticated: false,
  error: false,
  jwtExpiry: null,
  idleTicks: 0,
  authTicks: 0,
  firstName: '',
  lastName: '',
  lastActive: null,
  prevLastActive: null,
  roles: [],
  signout: false,
  forceSignout: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case types.GET_AUTH_TOKEN_SUCCESS:
    case types.REFRESH_SUCCESS:
      const decodedJwt = payload.decodedJwt;

      return {
        ...state,
        authenticated: true,
        decodedJwt: decodedJwt,
        jwtExpiry: decodedJwt.exp,
        firstName: decodedJwt.info.given_name,
        lastName: decodedJwt.info.family_name,
        reference: decodedJwt.info.customer_reference_number,
        roles: decodedJwt.info.role,
        authTicks: 0,
        idleTicks: 0,
        lastActive: null,
        prevLastActive: null,
        forceSignout: false,
      };
    case types.GET_AUTH_TOKEN_FAILURE:
      return {
        ...state,
        error: true,
      };
    case types.CLEAR_AUTH:
      return { ...initialState };
    case types.CLEAR_SIGNOUT:
      return { ...state, signout: false };
    case types.SIGNOUT:
      return { ...state, signout: true, forceSignout: payload.force };
    case types.SIGNOUT_SUCCESS:
      return { ...initialState, forceSignout: state.forceSignout };
    case types.TICK:
      let newAuthTicks = 0;
      if (state.authenticated) {
        newAuthTicks = state.authTicks + 1;
      }
      let tick = 1;
      if (state.authenticated && state.lastActive && state.prevLastActive) {
        tick =
          state.idleTicks +
          moment
            .unix(state.lastActive)
            .diff(moment.unix(state.prevLastActive), 'seconds');
      }

      return {
        ...state,
        authTicks: newAuthTicks,
        idleTicks: tick,
        lastActive: moment().unix(),
        prevLastActive: state.lastActive,
      };
    case appTypes.USER_INTERACTION:
      // On user interaction reset idle ticks
      return { ...state, idleTicks: 0 };
  }

  return state;
}

export const actions = {
  getAuthToken: () => ({
    type: types.GET_AUTH_TOKEN,
  }),
  signout: (force = false) => ({
    type: types.SIGNOUT,
    payload: { force },
  }),
  clearAuth: () => ({
    type: types.CLEAR_AUTH,
  }),
  clearSignout: () => ({
    type: types.CLEAR_SIGNOUT,
  }),
  tick: () => ({
    type: types.TICK,
  }),
  refresh: (error = () => {}) => ({
    type: types.REFRESH_REQUEST,
    payload: { error },
  }),
};
